import { FC } from 'react'
import cn from 'classnames'
import FormItem from 'antd/es/form/FormItem'
import { InputNew } from '@UI/InputNew'
import TooltipWrapper from '@UI/New/TooltipWrapper/TooltipWrapper'
import { RequestCreateLeadPaymentLink } from '@/api/types/crm/crm.types'
import sclasses from '../../../SetCourseClassDirectionModal/index.module.css'
import spclasses from '../../../SetCourseClassDirectionModal/purchase.module.css'
import CreateLinkSectionTitle from '../../CreateLinkSectionTitle'
import CreateLinkNumberInput, {
  createLinkNumberRuleTransform,
} from '../../CreateLinkNumberInput'
import { CREATE_LINK_BLOCK_TARIFF_TYPES } from '../../tariffTypes'
import { getCreateLinkBlockTariffTypesHint } from '../../createLinkBlockInfoContent'

type FieldType = Omit<RequestCreateLeadPaymentLink, 'lead_funnel_id'>

type IndividualLessonPriceFieldsProps = {
  suggestedPrice: number
  priceManuallyEdited: boolean
  firstPrice?: number | null
  lessonCount?: number | null
  /** false без фиксации кол-ва занятий (hour / minute / group_per_lesson). */
  priceEditable?: boolean
  onPriceManualChange: () => void
  onResetSuggestedPrice: () => void
}

const PRICE_LOCKED_TOOLTIP =
  'Итого считается автоматически (цена занятия × количество). Чтобы задать сумму вручную, зафиксируйте количество занятий.'

/**
 * Итого к оплате для hour / minute / group_per_lesson —
 * авторасчёт, ручной ввод (если разрешён), «вернуть расчётную».
 */
const IndividualLessonPriceFields: FC<IndividualLessonPriceFieldsProps> = ({
  suggestedPrice,
  priceManuallyEdited,
  firstPrice,
  lessonCount,
  priceEditable = true,
  onPriceManualChange,
  onResetSuggestedPrice,
}) => {
  const lessonPrice = Number(firstPrice)
  const lessons = Number(lessonCount)
  const tariffDescription =
    Number.isFinite(lessonPrice) &&
    Number.isFinite(lessons) &&
    lessons >= 1
      ? `Цена занятия: ${lessonPrice} ₽ × ${lessons} зан.`
      : null

  const priceInput = priceEditable ? (
    <FormItem<FieldType>
      name="price"
      rules={[
        {
          required: true,
          message: 'Укажите итоговую стоимость',
        },
        {
          type: 'number',
          min: 0,
          message: 'Цена не может быть отрицательной',
          transform: createLinkNumberRuleTransform,
        },
      ]}
      noStyle
    >
      <CreateLinkNumberInput
        className={spclasses.input}
        min={0}
        step={0.01}
        placeholder={0}
        onChange={() => onPriceManualChange()}
      />
    </FormItem>
  ) : (
    <FormItem<FieldType> name="price" hidden>
      <input type="hidden" />
    </FormItem>
  )

  return (
    <div className={spclasses.inputWithLabel}>
      <CreateLinkSectionTitle
        title="Итого к оплате"
        infoText={getCreateLinkBlockTariffTypesHint(
          CREATE_LINK_BLOCK_TARIFF_TYPES.lessonPrice,
        )}
      />
      {priceEditable ? (
        priceInput
      ) : (
        <TooltipWrapper placement="top" title={PRICE_LOCKED_TOOLTIP}>
          <span style={{ display: 'block', cursor: 'not-allowed' }}>
            {/* @ts-ignore */}
            <InputNew
              className={cn(spclasses.input, spclasses.disabledInput)}
              type="text"
              value={suggestedPrice}
              disabled
            />
            {priceInput}
          </span>
        </TooltipWrapper>
      )}
      <div className={sclasses.textDescription}>
        Расчётная сумма: {suggestedPrice} ₽
        {tariffDescription ? <div>{tariffDescription}</div> : null}
        {priceEditable && priceManuallyEdited ? (
          <button
            type="button"
            onClick={onResetSuggestedPrice}
            style={{
              marginLeft: 8,
              padding: 0,
              border: 'none',
              background: 'transparent',
              color: 'var(--color-accent-vivid)',
              cursor: 'pointer',
            }}
          >
            вернуть расчётную
          </button>
        ) : null}
      </div>
    </div>
  )
}

export default IndividualLessonPriceFields
